import style from '../yeah.module.scss'
import { InView } from "react-intersection-observer"
import animations from '@styles/animations.module.scss'
import Image from 'next/image'

interface IShoppingBagSectionProps {
    title: string;
    subtitle: string;
    imageSrc: string;
    imageAlt: string;
}

const ShoppingBagSectionYeah = ({ title, subtitle, imageSrc, imageAlt }: IShoppingBagSectionProps) => {
    return (
        <section className={`${style.section} ${style.section_pb120} ${style.section_px80}`}>
            <div className={`${style.container} ${style.shopBag}`}>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry?.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${style.title} ${animations.scroll__animation} ${style.title_middle} ${style.text_align_c} ${style.mb24}`}>
                                {title}
                            </div>
                        )
                    }}
                </InView>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry?.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${style.text} ${animations.scroll__animation} ${style.text_middle} ${style.text_align_c} ${style.shopBag__subtitle}`}>
                                {subtitle}
                            </div>
                        )
                    }}
                </InView>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry?.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${style.image} ${animations.scroll__animation} ${style.image_shopBag}`}>
                                <Image src={imageSrc} layout={'fill'} alt={imageAlt} />
                            </div>
                        )
                    }}
                </InView>
            </div>
        </section>
    )
}

export default ShoppingBagSectionYeah;
